import { render, staticRenderFns } from "./FriendCreatePage.vue?vue&type=template&id=790886a3&scoped=true&"
import script from "./FriendCreatePage.vue?vue&type=script&lang=js&"
export * from "./FriendCreatePage.vue?vue&type=script&lang=js&"
import style0 from "./FriendCreatePage.vue?vue&type=style&index=0&id=790886a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790886a3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('790886a3')) {
      api.createRecord('790886a3', component.options)
    } else {
      api.reload('790886a3', component.options)
    }
    module.hot.accept("./FriendCreatePage.vue?vue&type=template&id=790886a3&scoped=true&", function () {
      api.rerender('790886a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/FriendCreatePage.vue"
export default component.exports